const PageStruct = {
    id: 'sign-in',
    useLayout: true,
    children: [{ id: 'sign-in', order: 1 }]
};

export default PageStruct;
